import React, { Component } from 'react'

export default class UserItem extends Component {

    constructor(props){
        super(props);
        this.state = {};
    }

    componentWillReceiveProps(nextProps){

    }

    render() {
        return (
            <div style={{display: 'flex', flexDirection: 'column', marginBottom: 5}}>
                <span className="separator"/>
                <div style={{display: 'flex', flexDirection: 'row'}}>
                    <input type="checkbox"
                           // checked={this.state.isChecked}
                           onChange={(event) => {this.props.onToggleReceiver(this.props.login, event.target.checked)}}
                           style={{marginRight: 5, marginLeft: 5}}/>
                    {this.props.onlineStatus
                    ?
                    <div style={{backgroundColor: '#43a047', borderRadius: 5, width: 10, height: 10, marginTop: 3, marginRight: 3}}/>
                    :
                    <span style={{width: 13}}/>}
                    <div>
                        {this.props.nameWithLogin}<br/><span style={{fontSize: 14, color: '#666'}}>{this.props.type}</span>
                    </div>
                </div>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/notifictions/UserItem.js